import React, { FC } from 'react'

interface IProps {
  imageSrc?: string
  fileName?: string
}

const normalizeImageSrc = (imageSrc: string) => {
  if (/^(data:image\/|https?:\/\/|blob:)/.test(imageSrc)) {
    return imageSrc
  }

  return `data:image/png;base64,${imageSrc}`
}

const triggerDownload = (href: string, fileName: string) => {
  const link = document.createElement('a')
  link.href = href
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const DownloadQrImage: FC<IProps> = ({ imageSrc, fileName = 'qr-thanh-toan.png' }: IProps) => {
  const handleDownload = async () => {
    if (!imageSrc) {
      return
    }

    const src = normalizeImageSrc(imageSrc)

    if (/^(data:image\/|blob:)/.test(src)) {
      triggerDownload(src, fileName)
      return
    }

    try {
      const response = await fetch(src)
      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      triggerDownload(objectUrl, fileName)
      URL.revokeObjectURL(objectUrl)
    } catch (error) {
      triggerDownload(src, fileName)
    }
  }

  if (!imageSrc) {
    return null
  }

  return (
    <button
      type="button"
      onClick={handleDownload}
      className="mx-auto mt-3 block cursor-pointer bg-transparent text-center text-[15px] font-[500] text-[#045993] underline"
    >
      Tải ảnh Qr về thiết bị
    </button>
  )
}

export default DownloadQrImage
